var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cui__uncontent"},[_c('div',{staticClass:"biz-container"},[_c('CatalogueByCategory')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }